module.exports = __webpack_public_path__ + "6c18eb2bb5c0655df6b32bd8e6ec0dba.png";